module.exports = __webpack_public_path__ + "static/image_banner-93a7e8e4893dbfd874434e2b5846b428.png";